import { Form } from '@unform/web';
import { darken, lighten } from 'polished';
import styled from 'styled-components';

import backgroungImg from 'assets/sun-tornado.svg';
import { COLORS } from 'styles/constants';

export const Container = styled.div`
  width: 100%;
  min-height: 81vh;

  background: url(${backgroungImg}) no-repeat center;
  background-size: cover;

  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (min-width: 1400px) {
    min-height: 86vh;
  }
`;

export const ServiceForm = styled(Form)`
  width: 80%;
  margin: 30px 0;
  padding: 20px 0;

  border-radius: 10px;
  background: ${darken(0.02, COLORS.white)};

  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    color: ${COLORS.darktext};
    font-size: 30px;
    margin-bottom: 20px;
  }

  @media only screen and (max-width: 900px) {
    width: 90%;
  }
`;

export const ServiceFormFields = styled.div`
  width: 100%;
  padding: 20px 30px;

  background: ${lighten(0.3, COLORS.primary)};

  display: flex;
  justify-content: space-between;
  flex-direction: row;

  @media only screen and (max-width: 900px) {
    flex-direction: column;

    padding: 10px 30px;
  }
`;

export const ServiceFormSection = styled.div`
  width: 45%;

  h3 {
    margin-bottom: 15px;
  }

  > div {
    margin-bottom: 8px;
  }

  @media only screen and (max-width: 900px) {
    width: 100%;

    h3 {
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }
`;
